console.log("App init");